// Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:
export const PASSWORD_MATCHES = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}$/;
export const INSIDE_TEXT_EMAIL_MATCH = /\S+@\S+\.\S+/g;
export const EMAIL_MATCHES = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
export const NUMBERS_LETTERS_SPACE_HYPHEN_MATCHES = /^[A-Za-z0-9\- ]+$/;
export const LICENSE_MATCHES = /^[A-Za-z0-9\-. ]+$/;
export const NAME_MATCHES = /^[\p{L}\p{M}\p{P}\s]+$/gu;
export const ENGLISH_MATCHES = /^[A-Za-z0-9!#$%&'*+-=?^_`{| ]+$/;
export const ENGLISH_MATCHES_WITH_SPACE = /^[A-Za-z0-9!#$%&'*+-=?^_`{| ]+$/;
export const ENGLISH_MATCHES_WITH_ENTER =
  /^[\s\w\d\x21-\x2f\x3a-\x40\x5b-\x60\x7b-\x7e!@#$%&\^'"“”’*+-–—=?^_`{|\r\n ]+$/;
export const NUMBERS_MATCHES = /^\d+$/;
export const MONTH_YEAR_MATCHES = /(0[0-9]|1[0-2])\/(\d{4})/;
export const VALID_YEAR_MATCHES = /(?:(?:19|20)[0-9]{2})/;
export const PHONE_MATCHES = /^[() 0-9\-+]{10,15}$/;
export const ARRAY_PROPERTY = /(.*)\[(\d)\].(.*)/;

export const NO_NULL_UUID_MATCH = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const URL_MATCH = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
